import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Fullscreen from "./Fullscreen"
import { useAuth } from '../hooks/Auth'

function UnauthorizedPage() {
  return (
    <Fullscreen>
      <div className="container mt--8 pb-5">Unauthorized
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-7">
            <div className="card bg-secondary shadow border-0">
              <div className="card-body px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <h2>Unauthorized</h2>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6">
                <a href="https://www.flashtech.nl/nl/over-ons/ihub" className="text-light">
                  <small>Product Info</small>
                </a>
              </div>
              <div className="col-6 text-right">
                <a href="https://www.flashtech.nl/nl/contact" className="text-light">
                  <small>Contact Us</small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fullscreen>
  )
}

export default function PrivateRoute({ children, user, superuser=false, feature=null, ...rest }) {
  const location = useLocation()
  const auth = useAuth()
  if (!user && !auth.token) {
    return <Navigate to="/login" state={{ from: location }}/>
  }
  const isAllowed = (!feature || user.permissions.includes(feature)) && (!superuser || user.is_superuser)
  return (isAllowed ? children : <UnauthorizedPage/>)
}